import styles from './Placeholder.module.css';

export default function Revenue() {
  return (
    <div className={styles.container}>
      <h1>Revenue</h1>
      <p className={styles.subtitle}>Revenue tracking with partner splits</p>

      <div className={styles.placeholder}>
        <p>Coming soon:</p>
        <ul>
          <li>Revenue buckets: Charsoft (100%), CSL Leesburg, Partnerships</li>
          <li>Revenue by app breakdown</li>
          <li>Expense tracking (GCP, Stripe fees, Printify)</li>
          <li>CSL quarterly donation calculation</li>
          <li>Partnership milestone tracking (Lea's Songbook)</li>
          <li>Coaching session revenue</li>
          <li>Transaction history</li>
          <li>Quarterly report generation</li>
        </ul>
      </div>
    </div>
  );
}
